import {
  OrderPicklist, OrderPicklistMovement
} from '../components/types'

export enum PicklistAction {
  Inited = 'Init',
  OpenDialog = 'OpenDialog',
  CloseDialog = 'CloseDialog',
  PicklistUpdating = 'PicklistUpdating',
  PicklistUpdated = 'PicklistUpdated',
  PicklistItemsUpdated = 'PicklistItemsUpdated',
  PicklistItemMovementsUpdated = 'PicklistItemMovementsUpdated',
  PostComment = 'PostComment',
  StartSync = 'StartSync',
  SyncCompleted = 'SyncCompleted',
  PicklistBatchNoUpdated = 'PicklistBatchNoUpdated',
  UpdateComment = 'UpdateComment'
}

interface Action {
  type: string,
  payload?: { 
    header? : OrderPicklist,
    items?: OrderPicklist[],
    comments?: OrderPicklist[],
    errorSync?: String,
    itemMovements?: OrderPicklistMovement[],
    updateBatchNo?: string
  },
}

interface PicklistState {
  header?: OrderPicklist,
  items: OrderPicklist[],
  comments: OrderPicklist[],
  itemMovements: OrderPicklistMovement[],
  showConfirmDialog: boolean,
  isSubmitting: boolean,
  isSyncing: boolean,
  errorMessage: String
}

export const INITIAL_STATE : PicklistState = {
  header: undefined, items: [], showConfirmDialog: false, comments: [], isSyncing: false, errorMessage: '', itemMovements: [],
  isSubmitting: false
}

const OrderPicklistReducer = (state: PicklistState, action: Action) : PicklistState => {
  const { type, payload } = action;
  switch (type) {
    case PicklistAction.OpenDialog:
      return { ...state, showConfirmDialog : true }
    case PicklistAction.CloseDialog:
      return { ...state, showConfirmDialog : false }
    case PicklistAction.Inited:
      return { ...state, 
        header: payload?.header, 
        items: payload?.items!,
        comments: payload?.comments!
      }
    case PicklistAction.PicklistUpdated:
      return { ...state, header: payload?.header, 
        showConfirmDialog: false, isSubmitting: false }
    case PicklistAction.PicklistItemsUpdated:
      return { ...state, items: payload?.items! }
    case PicklistAction.PostComment:
      return { ...state, comments: [...state.comments, ...payload?.comments!] }
    case PicklistAction.UpdateComment:
      const updatedComments = state.comments.map(c => {
        if (c.id === payload?.comments![0].id) {
          return payload?.comments![0]
        }
        return c
      })
      return { ...state, comments: updatedComments }
    case PicklistAction.StartSync:
      return { ...state, isSyncing: true, errorMessage: '' }
    case PicklistAction.SyncCompleted:
      return { ...state, isSyncing: false, errorMessage: payload?.errorSync!,
        itemMovements: payload?.itemMovements! 
      }
    case PicklistAction.PicklistItemMovementsUpdated:
      const signedAmountMovements = payload?.itemMovements!.map(mv => {
        const signedAmount = mv.movementType === '262' && mv.amount > 0 ? -mv.amount : mv.amount
        return { ...mv, amount: signedAmount }
      })
      return { ...state, itemMovements: signedAmountMovements! }
    case PicklistAction.PicklistUpdating:
      return { ...state, isSubmitting: true }
    case PicklistAction.PicklistBatchNoUpdated:
      return { ...state, header: {
        ...state?.header!, batchLotNo: payload?.updateBatchNo!
      }}
    default:
      return state;
  }
}

export default OrderPicklistReducer